(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  var form =
    document.getElementById('contact-form');


  if (!form) {
    return;
  }


  /*
   * إلغاء رسائل المتصفح الأصلية
   * مثل:
   * Please match the requested format.
   */
  form.setAttribute(
    'novalidate',
    'novalidate'
  );


  var htmlLang =
    document.documentElement.getAttribute('lang') || 'en';


  var isArabic =
    htmlLang.toLowerCase().indexOf('ar') === 0;


  var nameField =
    document.getElementById('name');


  var emailField =
    document.getElementById('email');


  var phoneField =
    document.getElementById('ContactForm-phone');


  var messageField =
    document.getElementById('message');


  var submitButton =
    form.querySelector(
      'button[type="submit"]'
    );


  /* =====================================================
     TRANSLATED MESSAGES
  ===================================================== */

  var messages = {

    ar: {

      nameRequired:
        'يرجى إدخال الاسم.',

      emailRequired:
        'يرجى إدخال البريد الإلكتروني.',

      emailInvalid:
        'يرجى إدخال بريد إلكتروني صحيح.',

      phoneRequired:
        'يرجى إدخال رقم الهاتف.',

      phoneInvalid:
        'يرجى إدخال رقم هاتف إماراتي صحيح، مثال: +971506656442',

      messageRequired:
        'يرجى كتابة الرسالة.'

    },


    en: {

      nameRequired:
        'Please enter your name.',

      emailRequired:
        'Please enter your email address.',

      emailInvalid:
        'Please enter a valid email address.',

      phoneRequired:
        'Please enter your phone number.',

      phoneInvalid:
        'Please enter a valid UAE phone number, e.g. +971506656442',

      messageRequired:
        'Please enter your message.'

    }

  };


  var text =
    isArabic
      ? messages.ar
      : messages.en;


  /* =====================================================
     CONVERT ARABIC NUMBERS
  ===================================================== */

  function normalizeDigits(value) {

    if (!value) {
      return '';
    }


    var arabicDigits =
      '٠١٢٣٤٥٦٧٨٩';


    var persianDigits =
      '۰۱۲۳۴۵۶۷۸۹';


    return String(value)

      .replace(
        /[٠-٩]/g,
        function (digit) {

          return arabicDigits.indexOf(
            digit
          );

        }
      )

      .replace(
        /[۰-۹]/g,
        function (digit) {

          return persianDigits.indexOf(
            digit
          );

        }
      );

  }


  /* =====================================================
     NORMALIZE UAE PHONE
  ===================================================== */

  function normalizePhone(value) {

    var phone =
      normalizeDigits(value)
        .trim()
        .replace(
          /[\s\-().]/g,
          ''
        );


    /*
      00971506656442
      ->
      +971506656442
    */

    if (/^00971/.test(phone)) {

      phone =
        '+971' +
        phone.substring(5);

    }


    /*
      971506656442
      ->
      +971506656442
    */

    else if (/^971/.test(phone)) {

      phone =
        '+' + phone;

    }


    /*
      0506656442
      ->
      +971506656442

      وكذلك أرقام الإمارات المحلية.
    */

    else if (
      /^0[1-9]\d{7,8}$/.test(phone)
    ) {

      phone =
        '+971' +
        phone.substring(1);

    }


    /*
      506656442
      ->
      +971506656442
    */

    else if (
      /^5\d{8}$/.test(phone)
    ) {

      phone =
        '+971' + phone;

    }


    return phone;

  }


  /* =====================================================
     UAE PHONE VALIDATION
  ===================================================== */

  function isValidUAEPhone(value) {

    var phone =
      normalizePhone(value);


    /*
      Mobile:
      +971506656442

      Landline examples are also accepted.
    */

    return /^\+971[1-9]\d{7,8}$/.test(
      phone
    );

  }


  /* =====================================================
     EMAIL VALIDATION
  ===================================================== */

  function isValidEmail(value) {

    var emailPattern =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    return emailPattern.test(value);

  }


  /* =====================================================
     ERROR ELEMENT
  ===================================================== */

  function getErrorElement(field) {

    if (!field) {
      return null;
    }


    var errorId =
      field.getAttribute(
        'aria-describedby'
      );


    if (!errorId) {
      return null;
    }


    return document.getElementById(
      errorId
    );

  }


  /* =====================================================
     SHOW ERROR
  ===================================================== */

  function showError(field, message) {

    if (!field) {
      return;
    }


    var errorElement =
      getErrorElement(field);


    field.classList.remove(
      'is-valid'
    );


    field.classList.add(
      'is-invalid'
    );


    field.setAttribute(
      'aria-invalid',
      'true'
    );


    if (errorElement) {

      errorElement.textContent =
        message;


      errorElement.classList.add(
        'is-visible'
      );

    }

  }


  /* =====================================================
     CLEAR ERROR
  ===================================================== */

  function clearError(field) {

    if (!field) {
      return;
    }


    var errorElement =
      getErrorElement(field);


    field.classList.remove(
      'is-invalid'
    );


    field.removeAttribute(
      'aria-invalid'
    );


    if (errorElement) {

      errorElement.textContent =
        '';


      errorElement.classList.remove(
        'is-visible'
      );

    }

  }


  /* =====================================================
     VALID
  ===================================================== */

  function markValid(field) {

    if (!field) {
      return;
    }


    clearError(field);


    field.classList.add(
      'is-valid'
    );

  }


  /* =====================================================
     NAME
  ===================================================== */

  function validateName() {

    if (!nameField) {
      return true;
    }


    var value =
      nameField.value.trim();


    if (!value) {

      showError(
        nameField,
        text.nameRequired
      );


      return false;

    }


    markValid(nameField);


    return true;

  }


  /* =====================================================
     EMAIL
  ===================================================== */

  function validateEmail() {

    if (!emailField) {
      return true;
    }


    var value =
      emailField.value.trim();


    if (!value) {

      showError(
        emailField,
        text.emailRequired
      );


      return false;

    }


    if (
      !isValidEmail(value)
    ) {

      showError(
        emailField,
        text.emailInvalid
      );


      return false;

    }


    markValid(emailField);


    return true;

  }


  /* =====================================================
     PHONE
  ===================================================== */

  function validatePhone() {

    if (!phoneField) {
      return true;
    }


    var value =
      phoneField.value.trim();


    if (!value) {

      showError(
        phoneField,
        text.phoneRequired
      );


      return false;

    }


    if (
      !isValidUAEPhone(value)
    ) {

      showError(
        phoneField,
        text.phoneInvalid
      );


      return false;

    }


    markValid(phoneField);


    return true;

  }


  /* =====================================================
     MESSAGE
  ===================================================== */

  function validateMessage() {

    if (!messageField) {
      return true;
    }


    var value =
      messageField.value.trim();


    if (!value) {

      showError(
        messageField,
        text.messageRequired
      );


      return false;

    }


    markValid(messageField);


    return true;

  }


  /* =====================================================
     WHILE TYPING
  ===================================================== */

  [
    nameField,
    emailField,
    phoneField,
    messageField

  ].forEach(function (field) {

    if (!field) {
      return;
    }


    field.addEventListener(
      'input',
      function () {

        field.classList.remove(
          'is-valid'
        );


        clearError(field);

      }
    );

  });


  /* =====================================================
     VALIDATE ON BLUR
  ===================================================== */

  if (nameField) {

    nameField.addEventListener(
      'blur',
      function () {

        if (
          nameField.value.trim()
        ) {

          validateName();

        }

      }
    );

  }


  if (emailField) {

    emailField.addEventListener(
      'blur',
      function () {

        if (
          emailField.value.trim()
        ) {

          validateEmail();

        }

      }
    );

  }


  if (phoneField) {

    phoneField.addEventListener(
      'blur',
      function () {

        if (
          phoneField.value.trim()
        ) {

          validatePhone();

        }

      }
    );

  }


  if (messageField) {

    messageField.addEventListener(
      'blur',
      function () {

        if (
          messageField.value.trim()
        ) {

          validateMessage();

        }

      }
    );

  }


  /* =====================================================
     SUBMIT
  ===================================================== */

  form.addEventListener(
    'submit',
    function (event) {


      var nameValid =
        validateName();


      var emailValid =
        validateEmail();


      var phoneValid =
        validatePhone();


      var messageValid =
        validateMessage();


      if (
        !nameValid ||
        !emailValid ||
        !phoneValid ||
        !messageValid
      ) {

        event.preventDefault();


        var firstInvalid =
          form.querySelector(
            '.is-invalid'
          );


        if (firstInvalid) {

          firstInvalid.focus();


          if (
            typeof firstInvalid.scrollIntoView ===
            'function'
          ) {

            firstInvalid.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });

          }

        }


        return;

      }


      /*
        إرسال رقم الهاتف إلى Shopify
        بصيغة موحدة.
      */

      if (phoneField) {

        phoneField.value =
          normalizePhone(
            phoneField.value
          );

      }


      if (submitButton) {

        submitButton.classList.add(
          'is-loading'
        );

      }

    }
  );


  /* =====================================================
     SERVER TOAST
  ===================================================== */

  var toasts =
    document.querySelectorAll(
      '.contact-toast'
    );


  toasts.forEach(
    function (toast) {

      var closeButton =
        toast.querySelector(
          '.contact-toast__close'
        );


      function closeToast() {

        toast.classList.add(
          'is-hiding'
        );


        window.setTimeout(
          function () {

            if (
              toast &&
              toast.parentNode
            ) {

              toast.parentNode.removeChild(
                toast
              );

            }

          },
          260
        );

      }


      if (closeButton) {

        closeButton.addEventListener(
          'click',
          closeToast
        );

      }


      /*
        إخفاء الإشعار تلقائيًا
        بعد 6 ثوانٍ.
      */

      window.setTimeout(
        closeToast,
        6000
      );

    }
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
